export default __webpack_public_path__ + "static/media/tokonomics.5c8e2103.png";